import axios from 'axios';
import createRetryRejector from '@/botdefence/createRetryRejector';
import queryString from 'query-string';
import snapshotBotDefence from '@/botdefence/snapshotBotDefence';
import { getProperty } from '@/common/oldMobile';

if (!axios.__nike_setup) {
    throw Error('axios wrong create order');
}

const snapshotClient = axios.create({
    withCredentials: true,
    paramsSerializer: function(params) {
        return queryString.stringify(params, { encode: false });
    },
    baseURL: getProperty('pushSnapshotAddress')
});

snapshotClient.interceptors.response.use(
    response => response.data,
    createRetryRejector(snapshotClient, snapshotBotDefence)
);

export default snapshotClient;
